import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Districts} from './districts.model';

export const loadDistrictss = createAction(
  '[Districts/API] Load Districtss',
  props<{ districtss: Districts[] }>()
);

export const addDistricts = createAction(
  '[Districts/API] Add Districts',
  props<{ districts: Districts }>()
);

export const upsertDistricts = createAction(
  '[Districts/API] Upsert Districts',
  props<{ districts: Districts }>()
);

export const addDistrictss = createAction(
  '[Districts/API] Add Districtss',
  props<{ districtss: Districts[] }>()
);

export const upsertDistrictss = createAction(
  '[Districts/API] Upsert Districtss',
  props<{ districtss: Districts[] }>()
);

export const updateDistricts = createAction(
  '[Districts/API] Update Districts',
  props<{ districts: Update<Districts> }>()
);

export const updateDistrictss = createAction(
  '[Districts/API] Update Districtss',
  props<{ districtss: Update<Districts>[] }>()
);

export const deleteDistricts = createAction(
  '[Districts/API] Delete Districts',
  props<{ id: string }>()
);

export const deleteDistrictss = createAction(
  '[Districts/API] Delete Districtss',
  props<{ ids: string[] }>()
);

export const clearDistrictss = createAction(
  '[Districts/API] Clear Districtss'
);


// Custom Actions
export const getAllDistricts = createAction(
  '[Districts/API] Get All Districts',
  props<{ regionalUniqueId?: string }>()
);
